import { Copy, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export function CopyButton({ value, label, testId, className = "" }) {
  const [copied, setCopied] = useState(false);
  const handle = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      toast.success(`${label || "Değer"} kopyalandı`);
      setTimeout(() => setCopied(false), 1400);
    } catch {
      toast.error("Kopyalanamadı");
    }
  };
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={handle}
      className={`inline-flex items-center justify-center w-7 h-7 rounded-lg border transition-all hover:brightness-125 shrink-0 ${className}`}
      style={{ borderColor: "var(--border-subtle)", background: "var(--bg-main)" }}
      title="Kopyala"
    >
      {copied ? <Check className="w-3.5 h-3.5 text-emerald-500" /> : <Copy className="w-3.5 h-3.5" style={{ color: "var(--text-secondary)" }} />}
    </button>
  );
}
